export default {
  id: 'administrativeData/DATE/v1',
  formSchema: {
    title: 'encounter:widget.administrativeData.date',
    type: 'object',
    required: ['id001'],
    properties: {
      id001: {
        type: 'string',
        title: 'encounter:widget.administrativeData.date'
      }
    }
  },
  uiSchema: {
    id001: {
      'ui:widget': 'customDatepickerWidget',
      'x-defaultFormDataKey': 'startedAt'
    },
    'x-customClass': 'admin-data-widget',
    'x-cancelBtnSize': 'sm',
    'x-saveBtnSize': 'sm'
  }
};
